import React, { memo, useState } from 'react';
import { Checkbox } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import withConnect from '../../hoc/withConnect';
import { isMainnet } from '../../configs/Configs.env';
import { actionCloseModal } from '../../components/Modal/Modal.actions';
import { ReactComponent as CheckedSvg } from '../../assets/svg/checked.svg';
import useActiveWeb3React from '../../hooks/useActiveWeb3React';
import { ChainId } from '../../configs/Connect/Configs.chainId';
import { Wrapper } from './CustomWalletModal.styled';
import { ACTION_TYPES } from '../Header/redux/Wallet.action';
import { IWallet, INetWork, networkList } from './HardData';

interface IWalletModalProps {
    tryActivation: (connector: any) => void;
    setChainId?: any;
}

const CustomWalletModal = ({ tryActivation, setChainId }: IWalletModalProps & any) => {
    const { deactivate } = useActiveWeb3React();
    const [activeNetwork, setActiveNetwork] = useState<any>(setChainId || '');
    const [activeWallet, setActiveWallet] = useState('');
    const [wallets, setWallets] = useState<IWallet[]>(
        networkList.find((item: INetWork) => item.chainNumb === setChainId)?.wallets || [],
    );

    const network = useSelector((state: any) => state.wallet);
    const dispatch = useDispatch();

    function onChangeNetwork(chainId: string) {
        setActiveNetwork(chainId);
        const arrWallet: IWallet[] = networkList.find((item: INetWork) => item.chainNumb === chainId)?.wallets || [];
        setWallets(arrWallet);
    }

    function getImgNetwork(item: INetWork) {
        return <img src={require(`../../assets/svg/network-logos/${item.icon}`)} alt="Icon" />;
    }

    function handleWallet(item: IWallet) {
        if (item.name === 'Wallet Connect' || item.name === 'Binance') {
            tryActivation(item.connector);
            // }
        } else {
            if (network.wallet !== item.name) {
                deactivate();
            }
            setActiveWallet(item.name);
            localStorage.setItem('connector', 'injected');
            tryActivation(item.connector);
            if (item.name !== 'Coin 98') {
                dispatch({
                    type: ACTION_TYPES.SET_CHAIN_ID,
                    payload: activeNetwork,
                });
                dispatch({
                    type: ACTION_TYPES.SET_WALLET,
                    payload: item.name,
                });
            } else {
                dispatch({
                    type: ACTION_TYPES.SET_CHAIN_ID,
                    payload: null,
                });
            }
            dispatch(actionCloseModal());
        }
    }

    const chooseWallet = () => {
        return (
            <div className="wallets">
                {wallets.map((item) => {
                    let classWallet = 'wallet';
                    if (item.name === activeWallet) {
                        classWallet += ' active-wallet';
                    }
                    return (
                        <div
                            key={item.name}
                            className={classWallet}
                            onClick={() => {
                                handleWallet(item);
                            }}
                        >
                            <div className="button-wallet">
                                <img src={require(`../../assets/svg/wallet-logos/${item.icon}`)} alt="Icon" />
                            </div>
                            <div className="name-wallet">{item.name}</div>
                        </div>
                    );
                })}
            </div>
        );
    };
    return (
        <Wrapper>
            <div className="options">
                <div className="choose-network">
                    <div className="title">1. Choose Network</div>
                    <div className="networks">
                        {networkList.map((item) => {
                            let classNetwork = 'network';
                            if (item.chainNumb === activeNetwork) {
                                classNetwork += ' active-network';
                            }
                            if (
                                isMainnet &&
                                (item.chainNumb === ChainId.BSC_TESTNET ||
                                    item.chainNumb === ChainId.FANTOM_TESTNET ||
                                    item.chainNumb === ChainId.MATIC_TESTNET ||
                                    item.chainNumb === ChainId.CRO_TESTNET ||
                                    item.chainNumb === ChainId.AVALANCHE_TESTNET)
                            ) {
                                return <></>;
                            }
                            return (
                                <div
                                    className={classNetwork}
                                    key={item.name}
                                    onClick={() => onChangeNetwork(item.chainNumb)}
                                >
                                    <div className="button-network">
                                        {getImgNetwork(item)}
                                        {item.chainNumb === activeNetwork && <CheckedSvg className="checked" />}
                                    </div>
                                    <div className="name-network">{item.name}</div>
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className="choose-wallets">
                    <div className="title">2. Choose Wallet</div>
                    {chooseWallet()}
                </div>
            </div>
        </Wrapper>
    );
};

export default withConnect(memo(CustomWalletModal));
